import { createReducer } from 'redux-starter-kit';
import {
  fetchTemplates,
  fetchTemplatesSuccess,
  fetchTemplatesFailure,
  setRelatedSearches,
  resetSettings,
  cacheSettings,
  clearResults,
  searchFor,
  setSearchFor,
  filterByCateg,
  changeOrder,
  preloadTemplate,
  fetchTemplate,
  fetchTemplateSuccess,
  fetchTemplateFailure
} from 'actions/templates';
import { loginSuccess, registerSuccess, logout } from 'actions/auth';

const defaultSettings = {
  searchFor: '',
  orderBy: 'created_at desc',
  categId: null,
  currentPage: 0
};
export default createReducer(
  {
    list: [],
    relatedSearches: [],
    ...defaultSettings,
    isLoading: false,
    batchSize: 9,
    hasMore: false,
    currentTemplate: null,
    prevState: null
  },
  {
    [clearResults]: state => ({
      ...state,
      list: [],
      currentPage: 0
    }),
    [resetSettings]: state => ({
      ...state,
      ...defaultSettings
    }),
    [cacheSettings]: state => {
      const { searchFor, categId } = state;
      return {
        ...state,
        prevState: JSON.stringify({ searchFor, categId })
      };
    },
    // Templates
    [fetchTemplates]: state => ({
      ...state,
      isLoading: true
    }),
    [fetchTemplatesSuccess]: (state, action) => ({
      ...state,
      list: [...state.list, ...action.payload.data],
      isLoading: false,
      currentPage: action.payload.current_page,
      hasMore: action.payload.current_page < action.payload.last_page
    }),
    [fetchTemplatesFailure]: state => ({
      ...state,
      isLoading: false,
      hasMore: false
      // should also display an error here probably
    }),
    [setRelatedSearches]: (state, action) => ({
      ...state,
      relatedSearches: action.payload || []
    }),
    [setSearchFor]: (state, action) => ({
      ...state,
      searchFor: action.payload
    }),
    [searchFor]: (state, action) => ({
      ...state,
      searchFor: action.payload
    }),
    [filterByCateg]: (state, action) => ({
      ...state,
      categId: action.payload
    }),
    [changeOrder]: (state, action) => ({
      ...state,
      orderBy: action.payload,
      list: [], // reset results
      currentPage: 0
    }),

    // Template
    [preloadTemplate]: (state, action) => ({
      ...state,
      currentTemplate: action.payload
    }),
    [fetchTemplate]: state => ({
      ...state,
      isLoading: true
    }),
    [fetchTemplateSuccess]: (state, action) => ({
      ...state,
      currentTemplate: action.payload,
      isLoading: false
    }),
    [fetchTemplateFailure]: state => ({
      ...state,
      current: false,
      isLoading: false
    }),

    // Auth
    [loginSuccess]: state => ({
      ...state,
      list: []
    }),
    [registerSuccess]: state => ({
      ...state,
      list: []
    }),
    [logout]: state => ({
      ...state,
      list: []
    })
  }
);
